import { useEffect, useRef, useState, useCallback } from "react";

const SLIDES = [
  { src: "/nova_graphic_1_customers_communicate.png", alt: "Nova graphic — customers communicate" },
  { src: "/nova_graphic_2_sell_schedule.png", alt: "Nova graphic — sell and schedule" },
  { src: "/nova_graphic_3_work_get_paid.png", alt: "Nova graphic — work and get paid" },
  { src: "/nova_graphic_4_grow_ai.png", alt: "Nova graphic — grow with AI" },
];

const AUTOPLAY_MS = 3000;

export const HeroGraphicCarousel = () => {
  const [index, setIndex] = useState(0);
  const [hover, setHover] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [kick, setKick] = useState(0);
  const timerRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  useEffect(() => {
    SLIDES.forEach((s) => {
      const img = new Image();
      img.src = s.src;
    });
  }, []);

  useEffect(() => {
    const onVisibility = () => setHidden(document.hidden);
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  useEffect(() => {
    if (hover || hidden) {
      clearTimer();
      return;
    }
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % SLIDES.length);
    }, AUTOPLAY_MS);
    return clearTimer;
  }, [hover, hidden, kick, clearTimer]);

  const goTo = (i) => {
    setIndex(i);
    setKick((k) => k + 1); // resets the autoplay timer
  };

  return (
    <div
      data-testid="hero-graphic-carousel"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="w-full"
    >
      <div className="relative w-full aspect-[3/2]">
        {SLIDES.map((s, i) => (
          <img
            key={s.src}
            src={s.src}
            alt={s.alt}
            draggable={false}
            data-testid={`carousel-slide-${i + 1}`}
            aria-hidden={i !== index}
            className={`absolute inset-0 w-full h-full object-contain select-none transition-[opacity,transform] duration-[650ms] ease-out motion-reduce:transform-none ${
              i === index
                ? "opacity-100 translate-x-0 scale-100"
                : "opacity-0 translate-x-2 scale-[0.99] pointer-events-none"
            }`}
          />
        ))}
      </div>

      <div className="mt-6 flex items-center justify-center gap-2.5" data-testid="carousel-dots">
        {SLIDES.map((s, i) => (
          <button
            key={s.src}
            type="button"
            onClick={() => goTo(i)}
            data-testid={`carousel-dot-${i + 1}`}
            aria-label={`Show graphic ${i + 1}`}
            aria-current={i === index}
            className={`h-2.5 rounded-full transition-[width,background-color] duration-500 ${
              i === index
                ? "w-6 bg-nova-blue"
                : "w-2.5 bg-slate-200 hover:bg-nova-bluelight"
            }`}
          />
        ))}
      </div>
    </div>
  );
};
